<script>
import HorizontalTopbar from "@/components/horizontal-topbar";
import HorizontalNav from "@/components/horizontal-nav";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";

import {layoutComputed} from "@/state/helpers";
import {mapState} from "vuex";
import UserBranchWarehouseDialog from "@/components/shared/UserBranchWarehouseDialog.vue";
import AnnouncementDialog from "@/components/announcement/AnnouncementDialog.vue";
import FilterDialog from "@/components/product-search/dialogs/FilterDialog.vue";

/**
 * Horizontal-layout
 */
export default {
  props: {},
  components: {
    FilterDialog,
    AnnouncementDialog,
    UserBranchWarehouseDialog,
    HorizontalTopbar,
    HorizontalNav,
    Footer,
    RightBar,
  },
  data() {
    return {
      userRoleId: this.$store.state.auth.user.RoleGroupId,
      showUserBranchWarehouseDialog: false,
      showAnnouncementDialog: false,
    };
  },
  computed: {
    ...layoutComputed,
    ...mapState("settings", ["erpSettings"]),
    ...mapState("filterNavigation",["dialog"])
  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleMenu() {
      this.menu = true;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <HorizontalTopbar :type="topbar" :width="layoutWidth"/>
      <HorizontalNav/>
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">
        <div class="page-content animate-layout">
          <div class="container-fluid">
            <slot/>
            <div class="selectMenuu">
              <v-btn
                  class="btn-primary"
                  @click="showAnnouncementDialog = true"
                  fab
              >
                <v-icon >
                  mdi-information-variant
                </v-icon>
              </v-btn>
              <div style="margin-top: 2px; ">Duyurular</div>
            </div>
            <div v-if="erpSettings.userBranch && (userRoleId === '1' || userRoleId === 1)" class="selectMenu">
              <v-btn
                  color="blue darken-2"
                  dark
                  fab
                  @click="showUserBranchWarehouseDialog = true"
              >
                <v-icon>
                  mdi-home-plus
                </v-icon>
              </v-btn>
              <div style="margin-top: 2px;">Şube & Depo</div>
            </div>
            <AnnouncementDialog
                :showDialog="showAnnouncementDialog"
                @dialogChange="data => (showAnnouncementDialog = data)"
            >
            </AnnouncementDialog>
            <UserBranchWarehouseDialog
                :showDialog="showUserBranchWarehouseDialog"
                @dialogChange="data => (showUserBranchWarehouseDialog = data)"
            >
            </UserBranchWarehouseDialog>
          </div>

          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->
        <Footer/>
      </div>
      <!-- end main content-->
    </div>

    <!-- END layout-wrapper -->
    <RightBar/>
    <FilterDialog :show-dialog="dialog"></FilterDialog>
  </div>
</template>

<style scoped>
.selectMenu {
  text-align: center;
  position: fixed;
  bottom: 10px;
  z-index: 999;
  right: 20px;
}
.selectMenuu {
  animation: pulse 1s infinite;
  text-align: center;
  position: fixed;
  bottom: 10px;
  z-index: 999;
  left: 20px;
}

.v-dialog .custom-dialog {
  position: fixed;
  bottom: 10px;
  right: 20px;
  transform: translate(0, 100%);
}

.animate-layout {
  animation-name: example;
  animation-duration: .8s;
  animation-timing-function: ease-in;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes example {
  from {
    opacity: .1;
  }
  to {
    opacity: 1;
  }
}
</style>
